import { View } from 'backbone.marionette';
import './index.styl';
import template from './index.jst';
import _ from "lodash";
import { LocalStorage } from "../../../../../core/utils/Storage";

export default class WhatsNewView extends View {
	get template() {
		return template;
	}
	get file_name() {
		return 'nrl';
	}

	get var_name() {
		return 'whats_new.items[0].text';
	}
	initialize() {
		this.model.set({
			whats_new_html: ''
		});
		this.init()
	}
	init() {
		const whats_new_html = _.result(window, 'EXPORTS.GLOBAL_DATA.whats_new', '');

		if (whats_new_html !== '') {
			return this.setAttributes();
		}

		window.EXPORTS = {
			GLOBAL_DATA: {}
		};

		const header_info_script = document.createElement('script'),
			ABSPATH = process.env.ABSPATH,
			version = `?v=${LocalStorage.get('web_version') || Date.now()}`,
			path = `${ABSPATH}cms/whats-new/${this.file_name}.js${version}`
		;

		header_info_script.onload = this.setAttributes.bind(this);

		header_info_script.setAttribute('src', path);

		document.head.appendChild(header_info_script);

		return this;
	}

	setAttributes() {
		const whats_new_html = _.result(window.EXPORTS.GLOBAL_DATA, this.var_name, '');

		this.model.set({
			whats_new_html
		});

		this.render();
	}
	get className() {
		return "help-page whats-new";
	}
}